"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.citation-container {\n  text-align: left;\n  width: 100%; }\n  .citation-container .citation {\n    max-width: 648px; }\n  .citation-container .author {\n    font-size: 12px; }\n\n@media (max-width: 42rem) {\n  .citation {\n    margin-right: 24px; } }\n\n@media (max-width: 66rem) {\n  .citation-container .citation {\n    max-width: 452px; } }\n";
  const fileName = "Citation_Citation";
  const element = document.querySelector("style[data-sass-component='Citation_Citation']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Citation = _ref => {
  let {
    citation,
    author,
    lang
  } = _ref;
  const authorTitle = author && author.length ? author[0].author_title || author[0].author_name?.original_title && author[0].author_name?.original_title[0]?.value || '' : '';
  const firstCharacter = lang === 'fr' ? '« ' : '«';
  const lastCharacter = lang === 'fr' ? ' »' : '»';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "citation-container sia-margin-05-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-border-01-top sia-border-01-bottom sia-padding-02-top sia-padding-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, citation && citation.length > 0 && /*#__PURE__*/_react.default.createElement("p", {
    className: "citation sia-text-12",
    dangerouslySetInnerHTML: {
      __html: `${firstCharacter}${citation[0]?.replace('<p>', '').replace('</p>', '')}${lastCharacter}`
    }
  }), author && author.length > 0 && /*#__PURE__*/_react.default.createElement("p", {
    className: "author sia-text-11 sia-margin-02-top"
  }, authorTitle, " ", author[0].author_name?.name))));
};
var _default = exports.default = Citation;